import { useState } from "react";
import { FileInput, FileField, Labeled, useRecordContext } from "react-admin";
import { Box } from "@mui/material";
import AddIcon from "@mui/icons-material/Add";
import { customFile } from "features/customFile";
import { documentRequests } from "api/documentsApi";
import DocumentFileLink from "./DocumentFileLink";

const ACCEPTED_FORMATS = {
  "image/png": [".png"],
  "image/jpeg": [".jpg", ".jpeg"],
  "application/pdf": [".pdf"],
  "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet": [".xlsx"],
  "application/vnd.openxmlformats-officedocument.wordprocessingml.document": [".docx"],
  "application/msword": [".doc"],
};

const DocumentFileInput = ({
  label,
  source,
  documentName = label,
  onUploadSuccess,
  placeholder = "Добавете файл в формат: .png, .jpg, .jpeg, .pdf, .xlsx, .docx, или doc",
  subCategoryId = 17,
  uploadUrl,
  fileOnly = false,
  validate,
  downloadUrl,
}) => {
  const record = useRecordContext();
  const [uploadedId, setUploadedId] = useState(null);

  const recordId = record?.[source] && typeof record[source] === "number" ? record[source] : null;
  const existingId = uploadedId ?? recordId;

  const handleChange = e => {
    if (e) {
      customFile(
        uploadUrl ?? documentRequests.postPrivateDocuments(),
        fileOnly ? { File: e } : { File: e, SubCategoryId: subCategoryId, name: "DocumentName" },
        "POST",
        null,
        true,
      ).then(response => {
        setUploadedId(response.data?.id ?? response.data);
        if (onUploadSuccess) {
          onUploadSuccess(response.data);
        }
      });
    }
  };

  return (
    <Box>
      <FileInput
        format={value => (typeof value === "number" ? null : value)}
        placeholder={
          <Box sx={{ display: "flex", alignItems: "center", justifyContent: "center", gap: 1 }}>
            <AddIcon />
            {existingId ? "Качете нов файл за замяна" : placeholder}
          </Box>
        }
        label={label}
        source={source}
        accept={ACCEPTED_FORMATS}
        onChange={handleChange}
        validate={validate}
      >
        <FileField
          source="src"
          title="title"
        />
      </FileInput>
      {existingId && (
        <Labeled label="Прикачен файл">
          <DocumentFileLink
            id={existingId}
            documentName={documentName}
            url={downloadUrl ? downloadUrl(existingId) : undefined}
          />
        </Labeled>
      )}
    </Box>
  );
};

export default DocumentFileInput;
